/**
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button} from "antd";
import DialogBtn1000 from "./DialogBtn1000";

export default class DialogButtonBtn1000 extends DialogBtn1000 {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
    }

    getBtn(){
        let mLeft = this.props.btn.marginLeft||"";
        let type = this.props.btn.type||"";
        let color = this.props.btn.color||"#fff";
        let background = this.props.btn.background||"#0050B3";
        if(type=='text') {
            return (<div style={{color: "#0050B3",cursor:"pointer",marginLeft:mLeft?mLeft:""}} onClick={()=>{
                this.btnClick(this.props.record)
            }} >{this.props.btnText}</div>)
        }
        else {
            return (<Button style={{color: color, background: background,marginLeft:mLeft?mLeft:""}} onClick={()=>{
                this.btnClick(this.props.record)
            }} >{this.props.btnText}</Button>)
        }
    }

}